import { BOLT_BOOTSTRAP_ID } from '~/lib/constants';
import { updateChat } from '~/lib/persistence/chats';
import { type ProjectData } from '~/lib/projects';
import { getDeployInformationMessage } from '~/lib/projects/deploy-info-message';
import { projectStore } from '~/lib/stores/project';
import { workbenchStore } from '~/lib/stores/workbench';
import type { ProjectDeploymentInfo } from '~/routes/api.deploy.$project.($id)';
import type { Message } from '~/types/chat';
import { stripIndents } from '~/utils/stripIndent';

/**
 * Import files into WebContainer and update the chat.
 */
export function hydrate({ id, appFiles, title, editedAt }: ProjectData, hydration?: Hydration) {
  workbenchStore.importProjectFiles(appFiles);

  const projectSlug = projectStore.getSlug();

  if (projectSlug) {
    projectStore.setEditedAt(editedAt);
  }

  updateChat(id, { description: title });

  if (hydration) {
    return hydrateMessages(hydration);
  }

  return [];
}

interface Hydration {
  injectBootstrapMessage: boolean;
  message?: string;
  deploymentInfo?: ProjectDeploymentInfo;
  supportCustomDomains?: boolean;
}

export function hydrateMessages({ injectBootstrapMessage, deploymentInfo, message, supportCustomDomains }: Hydration) {
  const messages: Message[] = [];

  if (!injectBootstrapMessage) {
    return messages;
  }

  let importMessage = stripIndents`
    <boltArtifact id="bolt-bootstrap" title="Starting Project">
      <boltAction type="shell"><command>npm install</command></boltAction>
    </boltArtifact>
  `;

  importMessage += message ? `\n\n${message}` : '';

  if (deploymentInfo?.site_url) {
    importMessage += '\n\n' + getDeployInformationMessage(deploymentInfo, supportCustomDomains ?? false);
  }

  messages.push({
    id: BOLT_BOOTSTRAP_ID,
    merge: false,
    type: 'chat',
    status: 'complete',
    content: importMessage,
    role: 'assistant',
    hidden: true,
    ignore: true,
    parts: [],
  });

  return messages;
}
